<script lang="ts">
    import {onMount} from "svelte";

    enum WordAnalysisStatus {
        Normal,
        Add,
        Remove,
    }

    const DivisionText = "______LEXICA_DIVISION______";
    const GitDiffAddStart = '{+';
    const GitDiffAddEnd = '+}';
    const GitDiffRemoveStart = '[-';
    const GitDiffRemoveEnd = '-]';

    export let text;

    $: wordDataArray = (() => {
        if (text == null) {
            return null;
        }
        let wordDataArray = [];

        if (text.startsWith('+')) {
            // + からはじまっている場合は、行追加と判断する
            wordDataArray.push({sentence: text, type: '+'});
            return wordDataArray;
        }
        if (text.startsWith('-')) {
            // - からはじまっている場合は、行削除と判断する
            wordDataArray.push({sentence: text, type: '-'});
            return wordDataArray;
        }
        

        const textLength = text.length;
        let wordAnalysisStatus = WordAnalysisStatus.Normal;
        const charArray = [];
        for (let i = 0; i < textLength; i++) {
            const firstChar = text[i];
            if (textLength - 1 <= i) {
                // 最終文字の場合は処理せず終了
                charArray.push(firstChar);
                continue;
            }
            const secondChar = text[i + 1];

            let twoChar = null;

            if (wordAnalysisStatus === WordAnalysisStatus.Normal) {
                // 標準

                twoChar = text.slice(i, i + 2);
                if (twoChar === GitDiffAddStart) {
                    // 追加の始まり
                    charArray.push(DivisionText);
                    wordAnalysisStatus = WordAnalysisStatus.Add;
                } else if (twoChar === GitDiffRemoveStart) {
                    // 削除の始まり
                    charArray.push(DivisionText);
                    wordAnalysisStatus = WordAnalysisStatus.Remove;
                }

                charArray.push(firstChar);

            } else if (wordAnalysisStatus === WordAnalysisStatus.Add) {
                // 追加中
                charArray.push(firstChar);

                twoChar = text.slice(i - 1, i + 1);
                if (twoChar === GitDiffAddEnd) {
                    // 追加の終わり
                    charArray.push(DivisionText);
                    wordAnalysisStatus = WordAnalysisStatus.Normal;
                }
            } else if (wordAnalysisStatus === WordAnalysisStatus.Remove) {
                // 削除中

                charArray.push(firstChar);

                twoChar = text.slice(i - 1, i + 1);
                if (twoChar === GitDiffRemoveEnd) {
                    // 削除の終わり
                    charArray.push(DivisionText);
                    wordAnalysisStatus = WordAnalysisStatus.Normal;
                }


            }


        }
        const workText = charArray.join('');
        const workWordArray = workText.split(DivisionText);

        for (let workWord of workWordArray) {
            let type = '';
            if (workWord.startsWith(GitDiffAddStart)) {
                type = '+';
            } else if (workWord.startsWith(GitDiffRemoveStart)) {
                type = '-';
            }
            wordDataArray.push({sentence: workWord, type: type});
        }


        return wordDataArray;
    })();


    onMount(() => {
    });


</script>

<div class="diff-row-view"
     class:add={text.startsWith('+')}
     class:remove={text.startsWith('-')}
>
    {#if wordDataArray != null}
        {#each wordDataArray as wordData}
            {#if wordData.sentence !== ''}
            <span
                    class="word"
                    class:add={wordData.type === '+'}
                    class:remove={wordData.type === '-'}
            >
                { wordData.sentence }
            </span>
            {/if}
        {/each}
    {/if}


</div>
<style lang="scss">
    .diff-row-view {
        padding-left: 1em;
        padding-right: 1em;

        display: flex;
        flex-wrap: wrap;

        .word {
            &.add {
                background-color: #ebffea;
            }

            &.remove {
                background-color: #ffecec;
            }
        }


    }
</style>